import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useOutletContext } from "react-router";
import styled from "styled-components";
import { APP_TITLE } from "../../../config/constant";
import { defaultStatusColors } from "../../../utils/CardUtils";
import { userIsOnBoardingInPage } from "../../../utils/onboardingHelper";
import InfinityGridBrandsUsersCards from "../../common/cardContainers/InfinityGridBrandsUsersCards";
import ListComponent from "../../common/lists/ListComponent";
import MainWindowHeader from "../../common/mainApp/mainWindowHeaders/MainWindowHeader";

/* #region  SCOPED CSS */
const StyledPage = styled.div`
    & {
        overflow-y: hidden;
        height: 100%;
        margin-right: -23px;
        margin-left: -24px;
        padding-left: 24px;
        padding-right: 24px;
    }
`;
/* #endregion */

export default function BrandsUsersPage() {
    document.title = `${APP_TITLE} - Brand Users`;

    /* #region STATES */
    const { MainLayoutProps, layoutType } = useOutletContext();
    const props = {
        layoutType: layoutType,
        setControlBarLeftBtns: MainLayoutProps?.setControlBarLeftBtns,
        setControlBarCenterBtns: MainLayoutProps?.setControlBarCenterBtns,
        setControlBarRightBtns: MainLayoutProps?.setControlBarRightBtns,
        setFilterHeaderProperties: MainLayoutProps?.setFilterHeaderProperties,
        setRefreshUserData: MainLayoutProps?.setRefreshUserData
    };
    const navigations = useSelector(state => state.navigationAccesses);
    const gridRef = useRef(null);

    const [viewLayoutStyle, setViewLayoutStyle] = useState("Grid");
    const [listNumRows, setListNumRows] = useState(50);
    /* #endregion */

    /* #region EFFECTS */
    useEffect(() => {
        setViewLayoutStyle(props?.layoutType);
        setupHeaders(props, navigations);
    }, [props?.layoutType]);
    /* #endregion */

    /* #region LIST COMPONENT PROPS */
    const listColumns = [
        {
            name: "First Name",
            selector: row => row?.firstName ?? "--"
        },
        {
            name: "Last Name",
            selector: row => row?.lastName ?? "--"
        },
        {
            name: "Role",
            selector: row => row?.role ?? "--"
        },
        {
            name: "Stage Level",
            selector: row => row?.stageLevel ?? "Account" //TODO: Implement stage level
        },
        {
            name: "Mobile",
            selector: row => row?.mobile ?? "--"
        },
        {
            name: "Email",
            selector: row => row?.email ?? "--"
        }
    ];
    /* #endregion */

    return (
        <StyledPage>
            {viewLayoutStyle === "Grid" && (
                <InfinityGridBrandsUsersCards
                    ref={gridRef}
                    minColumnWidth="238px"
                    limit={12}
                    defaultSecondTitle="Brand:"
                />
            )}
            {viewLayoutStyle === "List" && (
                <ListComponent
                    title="Brands Users"
                    columns={listColumns}
                    api={{
                        endpoint: "getUsersData",
                        useCommonPostRequest: true,
                        commonContext: "Users",
                        formData: {
                            companyID: localStorage.getItem("currentCompanyID"),
                            organizationID: localStorage.getItem("currentOrganizationID"),
                            labelBrandsIDS: JSON.parse(localStorage.getItem("labelBrands"))?.map(it => it._id),
                            limit: listNumRows
                        }
                        //onSuccess: mapListData
                    }}
                    pageLimit={listNumRows}
                    currentPage={1}
                    queryKey={"getUsersData brands " + localStorage.getItem("activeBrands")}
                    actions={{ includeActions: true, extraActions: [{ title: "Details" }] }}
                    includeStatus={{
                        stickyStatus: true,
                        statusFromPath: "status",
                        statusColors: defaultStatusColors
                    }}
                    onChangeRowsPerPage={rowsPerPage => setListNumRows(rowsPerPage)}
                />
            )}
        </StyledPage>
    );
}

function setupHeaders(props, navigations) {
    const isUserBrandsOnboarding = userIsOnBoardingInPage(navigations, "retailBrands");
    const brandsTo = isUserBrandsOnboarding ? "/brands/create" : "/brands";

    props.setControlBarLeftBtns([{ to: "#", disabled: true, title: "Brands", icon: "fa-magnifying-glass" }]);
    props.setControlBarCenterBtns([
        { to: brandsTo, active: false, disabled: false, title: "Brands" },
        { to: "/brands/users", active: true, disabled: false, title: "Users" }
    ]);
    props.setControlBarRightBtns([
        { to: "#", active: true, disabled: false, title: "View", icon: "eye" },
        { to: "/brands/users/invite", active: false, disabled: true, title: "Invite", icon: "mail" },
        { to: "#", active: false, disabled: true, title: "Details", icon: "microscope" }
    ]);

    props.setFilterHeaderProperties({
        customContentHeader: (
            <MainWindowHeader
                key={window.location.pathname}
                visible={true}
                //onRefreshClick={onRefreshAction}
                layoutTypeOptions={{
                    gridEnabled: true,
                    listEnabled: true
                }}
                firstOrganize={{
                    visible: true,
                    disabled: true
                }}
                secondOrganize={{
                    visible: true,
                    disabled: true
                }}
                search={{
                    searchPlaceholder: "Search"
                    //onSearch: onSearch
                }}
            />
        )
    });
}
